<template>
  <div class="introduce" :class="{ right: right }">
    <div :style="{ background: background }">
      <div class="img">
        <van-image fit="cover" width="100%" height="100%" :src="img" />
      </div>
      <div class="title">{{ title }}</div>
      <div class="line"></div>
      <div class="desc">
        {{ (isMobile&&descMobile) ? descMobile : desc }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '产品介绍'
    },
    descMobile: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    img: {
      type: String,
      default: ''
    },
    background: {
      type: String,
      default: ''
    },
    right: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      data: {
        menu_list: [],
        isMobile: false
      }
    };
  },
  created() {
    if(document.body.clientWidth < 1000){
      this.isMobile = true
    } else{
      this.isMobile = false
    }
  },
  methods: {
    go() {
      this.$router.push({
        name: 'eg'
      });
    }
  }
};
</script>
<style lang="less" scoped>
.introduce {
  width: 100%;
  height: 487px;
  background: #fff;
  padding-top: 1px;
  margin-bottom: 200px;
  > div {
    width: 1200px;
    margin: 0 auto;
    background: #9aa4b9;
    min-height: 422px;
    margin-top: 120px;
    position: relative;
    padding-left: 546px;
    box-sizing: border-box;
    padding-top: 1px;
    padding-bottom: 40px;
    .img {
      position: absolute;
      top: -54px;
      left: 51px;
      width: 460px;
      height: 550px;
      padding: 12px;
      box-sizing: border-box;
      background: #fff;
      box-shadow: 1px 2px 5px 2px rgba(0, 0, 0, 0.08);
      border: 1px solid #efefef;
    }
    .title {
      font-size: 36px;
      font-weight: bold;
      color: #ffffff;
      line-height: 1;
      margin-top: 84px;
    }
    .line {
      margin-top: 10px;
      border-left: 71px solid #fdd917;
      border-right: 541px solid #c2bebe;
      height: 1px;
      width: 0px;
      position: relative;
      z-index: 2;
      margin-left: -13px;
    }
    .desc {
      width: 628px;
      font-size: 20px;
      font-weight: 400;
      color: #ffffff;
      line-height: 36px;
      margin-top: 10px;
      text-align: justify;
      span {
        display: block;
      }
    }
  }
}
.right {
  > div {
    padding-right: 546px;
    padding-left: 56px;
    .img {
      right: 51px;
      left: auto;
    }
  }
}
@media (max-width: 1000px) {
  div.main{
    .introduce{
      width: 100%;
      height: auto;
      margin-bottom: 0px;
      padding-top: 0;
      > div{
        width: 100%;
        height: auto;
        min-height: 100%;
        padding: 80px 48px;
        box-sizing: border-box;
        margin-top: 0;
        .title{
          font-size: 36px;
          color: #FFFFFF;
          letter-spacing: 0;
          font-weight: 500;
          margin-top: 0;
          line-height: 1;
        }
        .line {
          margin-top: 22px;
          border-left: 170px solid #fdd917;
          border-right: 480px solid #c2bebe;
          height: 2px;
          width: 0px;
          position: relative;
          z-index: 2;
          margin-left: -13px;
        }
        .desc {
          width: 326px;
          font-size: 26px;
          line-height: 40px;
          margin-top: 40px;
        }
        .img{
          width: 280px;
          height: 338px;
          top: 190px;
          right: 48px;
          left: auto;
          bottom: auto;
          padding: 0;
          border: none;
        }
      }
    }
  }
}
</style>
